import { CAPTCHA_ENABLED } from '../../../config';

export const CAPTCHA_PROVIDER_RECAPTCHA = 'recaptcha';
export const CAPTCHA_PROVIDER_ALTCHA = 'altcha-v3-sha256';

export const CAPTCHA_SECURITY_CONTEXT_STATUS_IDLE = 'idle';
export const CAPTCHA_SECURITY_CONTEXT_STATUS_LOADING = 'loading';
export const CAPTCHA_SECURITY_CONTEXT_STATUS_READY = 'ready';

export const ALTCHA_STATE_IDLE = 'idle';
export const ALTCHA_STATE_REQUESTED = 'requested';
export const ALTCHA_STATE_VERIFYING = 'verifying';
export const ALTCHA_STATE_VERIFIED = 'verified';
export const ALTCHA_STATE_ERROR = 'error';
export const ALTCHA_STATE_CODE = 'code';
export const ALTCHA_STATE_EXPIRED = 'expired';
export const ALTCHA_STATE_UNVERIFIED = 'unverified';

export const ALTCHA_WORKER_CONCURRENCY = 2;
export const ALTCHA_CHALLENGE_ENDPOINT = '/v1/altcha/challenge';

export const isCaptchaGloballyEnabled = () => CAPTCHA_ENABLED !== false;
export const isCaptchaRequired = (requireFeedbackCaptcha) => isCaptchaGloballyEnabled() && !!requireFeedbackCaptcha;

export const isRecaptchaProvider = (provider) => provider === CAPTCHA_PROVIDER_RECAPTCHA;
export const isAltchaProvider = (provider) => provider === CAPTCHA_PROVIDER_ALTCHA;
